import {
  HorizontalAxis,
  IHorizontalAxis,
} from '@common-modules/shared/charts/model/axes/horizontal-axis';
import {
  IVerticalAxis,
  VerticalAxis,
} from '@common-modules/shared/charts/model/axes/vertical-axis';
import { IChartCustomization } from '@common-modules/shared/charts/model/chart/chart-customization';
import { IChartConfiguration } from '@common-modules/shared/charts/model/chart/ichart-configuration';
import { IEventChartQuery } from '@common-modules/shared/charts/model/events/event-chart-query';
import { IPlotableSerie } from '@common-modules/shared/charts/model/series/plotable-serie';
import { IEventsControlSettings } from '@common-modules/shared/model/data-viz/events-control-settings.dto';
import { EventChartQueryDto } from '@common-modules/wlm-charts/core/events-chart/models/events-chart-query.dto';
import { Type } from 'class-transformer';

export class ChartConfiguration implements IChartConfiguration {
  eventsControlSettings: IEventsControlSettings;
  @Type(() => HorizontalAxis)
  horizontalAxis: IHorizontalAxis[];
  @Type(() => VerticalAxis)
  verticalAxis: IVerticalAxis[];
  seriesConfiguration: IPlotableSerie[];
  customization: IChartCustomization;
  @Type(() => EventChartQueryDto)
  eventsQuery?: IEventChartQuery;

  constructor(init: Partial<ChartConfiguration>) {
    Object.assign(this, init);
  }
}
